<!-- 全局引用的样式 -->
<style lang="scss">
@import './animate/side.scss';
@import './animate/none.scss';

/* 绝对定位 */
@mixin position-absolute() {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

body {
  &.disable-event {
    /* 不响应用户点击等操作 */
    pointer-events: none;
  }
}

/* 基础样式 */
.x3-router-view {
  @include position-absolute;
  overflow: hidden;
  z-index: 1;
}
.x3-router-page {
  @include position-absolute;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 0;
  /* 设计全局页面默认的背景色 */
  background-color: var(--g1);

  &.vx-in-init {
    animation: vx-in-init 300ms ease-in-out;
  }
}
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .x3-router-view {
    // bottom: constant(safe-area-inset-bottom);
    bottom: env(safe-area-inset-bottom);
  }
}

@keyframes vx-in-init {
  0% {
    transform: translate3d(0, 0, 1px);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}

/* 如需更改全局背景色，需要在应用层给一个全局的 x3-router-page 的background-color色 
  body .x3-router-page{
    background-color: #F00;
} */
</style>

<template>
  <div class="x3-router-view">
    <!-- 全局路由总线容器 -->
    <router-view></router-view>

    <template v-for="(obj, key) in spages">
      <component
        class="x3-router-page"
        v-if="obj.component"
        :is="obj.component"
        :key="key"
        :ref="key"
        :page-id="key"
        :isReplace="obj.isReplace"
        :class="[obj.animaName, {'is-wxwork': app.base.isIos && (app.base.env === 'wxwork')}]"
        :style="{ zIndex: obj.zIndex }"
        :$vxRoute="obj.$vxRoute"
      >
      </component>
    </template>
  </div>
</template>

<script>
import mixin from './mixin.js';

Vue.mixin({
  props: {
    $vxRoute: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
});

export default {
  name: 'vx-router-view',
  mixins: [mixin],
  props: {
    className: {
      type: String,
      default: '',
    },
    // 最多同时保留多少个页面
    max: {
      type: Number,
      default: 10,
    },
    // 路由切换是否做动画
    animate: {
      type: String,
      default: 'side',
    },
  },
  components: {},
  data() {
    return {
      // 每一页的'z-index'
      zIndex: 1,
      // 用于缓存已加载的页面路由组件(实际上是vue选项)
      caches: {},
      // 用于保存当前拉取过来的可以路由的组件(可以理解为一个page页组件类的集合); 示例如下：
      spages: {},
      harr: [],

      prevPagePromise: Promise.resolve((this._pageNum = 0)),
    };
  },
  computed: {},
  methods: {
    toPageHandler(toPageName) {
      let pageInstance = this.$refs[toPageName][0],
        title = pageInstance.pageTitle,
        vxshow = pageInstance.$options.vxshow;

      // 修改应用的title
      title && app.tool.setDocTitle(title);

      pageInstance.$emit('pageshow');

      vxshow && vxshow.call(pageInstance);
    },
    // 监听动画事件, 调整各页面的'z-index'的值;
    addAnimEvent() {
      // 动画开始
      window.addEventListener('webkitAnimationStart', e => {
        // 这一句的作用是，确保只对"vx-"，也就是路由页面级的动画做处理
        if (e.animationName.indexOf('vx-') === 0) {
          // console.log("路由动画开始 => ", e);

          let isIn = e.animationName.indexOf('vx-in-') === 0,
            isShow = e.animationName.indexOf('vx-show-') === 0;
          if (isIn || isShow) {
            this.toPageHandler(e.target.getAttribute('page-id'));
          }
        }
      });

      // 动画结束
      window.addEventListener('webkitAnimationEnd', e => {
        // 这一句的作用是，确保只对"vx-"，也就是路由页面级的动画做处理
        if (e.animationName.indexOf('vx-') === 0) {
          // console.log("路由动画完成 => ", e);

          // 恢复文档响应用户动作操作，如：点击等
          app.dom.removeClass(document.body, 'disable-event');

          // 如果是路由后退 或 是被(replace)替换掉的页面， 则进行销毁
          let isOut = e.animationName.indexOf('vx-out-') === 0,
            isreplace = e.target.getAttribute('isreplace');
          if (isOut || isreplace) {
            this.rmHarr(e.target.getAttribute('page-id'));
          }

          // 在动画完成后检查是否超出最大页面数量
          this.checkMax();
        }
      });
    },
    // 销毁页面
    deletePage(pageName) {
      try {
        // new:缓存页面.
        if (this.spages[pageName] && this.spages[pageName].$vxRoute.meta.isAlwaysCache) {        
          this.spages[pageName].zIndex = 0;
        } else {          
          Vue.delete(this.spages, pageName);
        }
      } catch(e) {
        Vue.delete(this.spages, pageName);
      }
      // console.log("销毁 。。。。。。。。。。。 ", pageName);
      // 将对应key赋值为空, 这时模板中的动态组件将会自动销毁相应页面

    },
    addHarr(toPageName) {
      this.harr.unshift(toPageName);
    },
    // 暴露出去的移除某个路由页面的方法
    rmHarr(pageName) {
      let index = this.harr.indexOf(pageName);
      if (index !== -1) {
        this.harr.splice(index, 1);
        this.deletePage(pageName);
      }
    },
    rm(arg) {
      if (typeof arg === 'string') {
        this.rmHarr(arg);
      } else if (Array.isArray(arg)) {
        arg.forEach(this.rmHarr);
      }
    },
    // 检查是否达到或超出预设的最大页面数，若超出则及时移除。
    checkMax() {
      if (this.harr.length > this.max) {
        let name = this.harr.pop();
        this.deletePage(name);
      }
    },
    // 是否匹配中路由，如果没有则导航到主页
    checkRoute() {
      let route = this.$route;
      // 当前路由未定义,进入默认路由页面
      if (route.path !== '/' && route.matched.length === 0) {
        this.$router.replace('/');
      }
    },
    // 获取页面组件
    async getPageComponent(to) {
      let toModuleName = to.name;
      return new Promise(async (resolve, reject) => {
        // 如果需要的页面路由组件不存在
        if (!this.caches[toModuleName]) {
          // 异步组件
          if (typeof to.meta.page === 'function') {
            let res = await to.meta.page();
            // 缓存
            this.caches[toModuleName] = res.default;
          } else {
            // 同步组件
            this.caches[toModuleName] = to.meta.page;
          }
        }

        resolve(this.caches[toModuleName]);
      });
    },
    /**
     * 确保获取页面组件的顺序，保障连继多次快速切换路由时，顺序能够正确。
     * 该方法体的代码顺序非常重要，请勿随意调整。
     */
    async getSyncPageComponent(to) {
      let prevPromise = this.prevPagePromise,
        prevPageResolve = '';

      this.prevPagePromise = new Promise((rsv, rej) => {
        prevPageResolve = rsv;
      });

      let pageComponent = await this.getPageComponent(to);

      await prevPromise;

      prevPageResolve(++this._pageNum);

      return pageComponent;
    },
    // 根据路由记录生成页面实例的key
    getPageKey(record) {
      let pageKey = record.fullPath,
        vx_exclude_params = record.meta.vx_exclude_params || [];

      // 这个数组里保存的是页面用于标识子状态的key
      if (vx_exclude_params.length > 0) {
        pageKey = `/${record.name}`;
        for (const key in record.params) {
          if (Object.hasOwnProperty.call(record.params, key)) {
            if (vx_exclude_params.indexOf(key) < 0) {
              pageKey += `/${record.params[key]}`;
            }
          }
        }
        pageKey += app.tool.jsonToQueryStr(record.query);
      }
      return pageKey;
    },
  },
  created() {
    this.fr.hasRouteIns = true;
    this.checkRoute();
    this.addAnimEvent();
    // window.vxRouter = this;
  },
  mounted() {},
  watch: {
    async $route(to, from) {
      let direc = this.fr.direction,
        routeMode = this.fr.routeMode,
        fromKey = `${this.getPageKey(from)}-${this.fr.prevKey}`,
        toKey = `${this.getPageKey(to)}-${this.fr.curKey}`;

      // new:缓存页面.
      if (from.meta.isAlwaysCache) {
        fromKey = `${this.getPageKey(from)}`;
      }
      if (to.meta.isAlwaysCache) {
        toKey = `${this.getPageKey(to)}`;
      }

      // 在路由切换时, 隐藏微信菜单中的非基础功能按钮
      app.sdk.triggerMenu(false);

      // console.log("vx-route route watch .... >>>>>>>>>>>>>>>>> ");
      // console.log(this.fr.isReady);
      // console.log("direc 0  => ", direc, routeMode);
      // console.log("fromKey =>  ", fromKey);
      // console.log("toKey =>  ", toKey);
      // console.log("from =>  ", from);
      // console.log("to =>  ", to);

      // 未进入应用之前(应用层是否new Vue()),如果调用了replace方法改变路由，则会进入这里。
      if (this.fr.isReady == false && direc == '') {
        this.fr.isReady = true;
        return;
      }

      // 如果这两个key相等，说明是同一个页面在改变子状态
      if (fromKey == toKey) {
        for (const key in to) {
          this.spages[toKey].$vxRoute[key] = to[key];
        }
        return;
      } else {
        // 将文档设为不响应用户动作操作，如：点击等；
        //  目的是防止用户多次点击文档上相关按钮等操作，导致页面响应没必要的导航
        app.dom.addClass(document.body, 'disable-event');
      }

      // 获取将要进入的页面的组件
      let component = await this.getSyncPageComponent(to);

      // 给每个页面级vue实例注入vxRoute
      if (!this.spages[toKey]) {
        this.addHarr(toKey);

        this.$set(this.spages, toKey, {
          component: component,
          animaName: '',
          isReplace: '',
          zIndex: this.zIndex++,
          $vxRoute: {
            ...to,
            vx_action: '',
          },
        });
      } else if (to.meta.isAlwaysCache && this.harr.indexOf(toKey) === -1) {
        this.addHarr(toKey);
        // new:缓存页面.
        this.spages[toKey].zIndex = this.zIndex++;
      }      

      // 根据路由的方向设置相应的值
      // '!this.spages[fromKey]'这个是为了解决在ios设备上，从一个新打开的页面返回本应用时产生的问题，
      // 此时direc会是'forward'，原因是这个情况会触发mixin.js中的'popstate'事件监听执行
      // 而事实上此时应用只能算初始进入
      if (direc == '' || !this.spages[fromKey]) {
        this.spages[toKey].$vxRoute.vx_action = `vx-in`;
        this.spages[toKey].animaName = 'vx-in-init';
      } else if (direc == 'forward') {
        // 如果是路由前进，则根据将要进入的页面配置的动画名来操作
        let animaName = to.meta.vx_animate || this.animate;

        this.spages[fromKey].$vxRoute.vx_action = `vx-hide`;
        this.spages[fromKey].animaName = `vx-hide-${animaName}`;

        this.spages[toKey].$vxRoute.vx_action = `vx-in`;
        this.spages[toKey].animaName = `vx-in-${animaName}`;

        // 如果目标页面替换当前页面，则给当前页打上"被替换"的标识,以方便动画完成后销毁
        if (routeMode == 'replace') {
          this.spages[fromKey].isReplace = true;
        }
      } else if (direc == 'back') {
        // 如果是路由后退，则根据将要出去的页面配置的动画名来操作
        let animaName = from.meta.vx_animate || this.animate;

        this.spages[fromKey].$vxRoute.vx_action = `vx-out`;
        this.spages[fromKey].animaName = `vx-out-${animaName}`;

        this.spages[toKey].$vxRoute.vx_action = `vx-show`;
        this.spages[toKey].animaName = `vx-show-${animaName}`;
      }
    },
  },
};
</script>
